export default (element) => {
  const menuListButtons = element.querySelectorAll(
    '[data-footer-menu-list-title]'
  );
  const newsletterForm = element.querySelector('#newsletter_form');
  const phoneForm = element.querySelector('#phoneForm');
  const forms = element.querySelectorAll('form');
  const buttons = element.querySelectorAll('button');
  const emailInput = element.querySelector('#email-footer');
  const phoneInput = element.querySelector('#phone-footer');
  const agreementInput = element.querySelector('#newsletter-agreement');
  const formEmailError = element.querySelector('#form-email-error-message');
  const formPhoneError = element.querySelector('#form-phone-error-message');
  const formConsentError = element.querySelector('#form-consent-message');

  const formEmailSuccess = element.querySelector(
    '[data-email-success-message]'
  );
  const subscriptionBody = element.querySelector('[data-subscription-body]');
  const formPhoneSuccess = element.querySelector('#phone_success_message');
  const formPhoneErrorResp = element.querySelector('#phone_error_message');
  const newsletterFormHeadline = element.querySelector(
    '#newsletter_form_headline'
  );
  const emailInputHidden = element.querySelector('#email-input-hidden');

  const menuLinkToggle = () => {
    menuListButtons.forEach((listItem) =>
      listItem.addEventListener("click", () => {
        listItem.lastElementChild.querySelector("path:last-child").classList.toggle("hidden");
        listItem.nextElementSibling.classList.toggle("hidden");
      })
    );
  };

  const validateEmail = (email) =>
    // eslint-disable-next-line no-useless-escape, max-len
    /^[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
      email
    );

  const validatePhoneNumber = (phone) =>
    phone.length === 10 &&
    // eslint-disable-next-line no-useless-escape
    /^[-\s\./0-9]*$/g.test(phone);



  const validateEmailForm = () => {
    const emailFormIsValid = validateEmail(emailInput.value);

    if (!emailFormIsValid) {
        formEmailError.classList.remove("hidden");
        emailInput.classList.add("error");
        emailInput.setAttribute('aria-describedby', formEmailError.id);
        emailInput.setAttribute('aria-invalid', true);
        emailInput.focus();
      } else {
        formEmailError.classList.add("hidden");
        emailInput.classList.remove("error");
        emailInput.removeAttribute('aria-describedby')
        emailInput.removeAttribute('aria-invalid');
      }
    return emailFormIsValid;
  };

  const validatePhoneForm = () => {
    const phoneIsValid = validatePhoneNumber(phoneInput.value.replace(/\D/g, ""));
     
    const formIsValid = phoneIsValid && agreementInput.checked;

    if (!formIsValid){

      if (!phoneIsValid ) {
        formPhoneError.classList.remove("hidden");
        phoneInput?.classList.add("error");
        phoneInput?.setAttribute('aria-describedby', formPhoneError.id);
        phoneInput?.setAttribute('aria-invalid', true);
        phoneInput?.focus();
      } else {
        formPhoneError.classList.add("hidden");
        phoneInput?.classList.remove("error");
        phoneInput?.removeAttribute('aria-describedby');
        phoneInput?.removeAttribute('aria-invalid');
      }
  
      if (!agreementInput.checked) {
        formConsentError.classList.remove("hidden");
        agreementInput?.setAttribute('aria-describedby', formConsentError.id);
        agreementInput?.setAttribute('aria-invalid', true);
        agreementInput?.focus();
      } else {
        formConsentError.classList.add("hidden");
        agreementInput?.removeAttribute('aria-describedby');
        agreementInput?.removeAttribute('aria-invalid');
      }
  
    }
    return formIsValid;
  };

  const changeHiddenClass = (
    showMessage,
    unshowMessage,
    unshowForm = false,
    showForm = false
  ) => {
    showMessage.classList.remove('hidden');
    unshowMessage.classList.add('hidden');
    if (showMessage.id === 'phone_success_message') {
      setTimeout(() => {
        showMessage.setAttribute('role', 'status');
        showMessage.setAttribute('tabindex', '0');
        showMessage.focus();
      }, 100);
    }
    if (unshowForm != false) {
      unshowForm.classList.add('hidden');
    }
    if (showForm != false) {
      showForm.classList.remove('hidden');
    }
  };

  const subscriptionRequest = (form) => {

    if (!form) {
        return;
    }

    if (emailInputHidden) {
        emailInputHidden.value = emailInput.value;
    }

    const formData = new FormData(form);

    const url = new URL(form.action);

    for (const [name, value] of formData.entries()) {
      url.searchParams.append(name, value);
    }

    fetch(url.toString(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
        },
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Subscription request response error.');
        }
        return response.text();
    })
    .catch(error => {
        console.error('Error during subscription fetch operation:', error);
    });

  }

  const sendPhoneForm = async (phone) => {
    const data = { phone };
    try {
      const response = await fetch(
        'https://quizzes-2-attentive-9bea693113d0.herokuapp.com/subscribe',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const result = await response.json();
      return { success: true, data: result };
    } catch (error) {
      return { success: false, message: error?.message };
    }
  };

  const formsValidation = (type) => {
    let formIsValid = false;

    if (type == "email") {
      formIsValid = validateEmailForm();
      if (!formIsValid) return;
      changeHiddenClass(formEmailSuccess, subscriptionBody, newsletterForm, phoneForm );
      subscriptionRequest(newsletterForm);
    }

    if (type == "phone") {
      formIsValid = validatePhoneForm();
      if (!formIsValid) return;
      // ? - what phone format ???
      sendPhoneForm(phoneInput?.value).then((res) => {
        const { success } = res;
        if (success) {
          changeHiddenClass(
            formPhoneSuccess,
            newsletterFormHeadline,
            phoneForm
          );
          // do this if we have a positive answer, but received an error beforehand
          changeHiddenClass(formPhoneSuccess, formPhoneErrorResp);
        } else {
          changeHiddenClass(formPhoneErrorResp, newsletterFormHeadline);
        }
      });
    }
  };

  const addMask = (e) => {
    const x = e.target.value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    e.target.value = `${x[1] ? `(${x[1]}) ` : ""}${x[2]}${x[3] ? `-${x[3]}` : ""}`;
  };

  phoneInput?.addEventListener("input", (e) => {
    if (e.inputType !== "deleteContentBackward" && e.inputType !== "deleteContentForward") {
      addMask(e);
    }
  });


  const initNewsletterForm = () => {
    if (buttons.length) {
      buttons.forEach((button) => {
        button.addEventListener("click", (event) => {

          event.preventDefault();
          event.stopImmediatePropagation();

          const formType = event.target.closest('form')?.dataset.formType;

          formsValidation(formType);
        });
      });
    }
  };

  function setEventListeners() {
    forms.forEach(form => {
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            const formType = form.dataset.formType;

            formsValidation(formType);
        });
    });
}

  const init = () => {
    menuLinkToggle();
    initNewsletterForm();
    setEventListeners();
  };
  init();
};

